import chargeTransactionApi from 'api/chargeTransactionApi';
import AppConstants from 'general/constants/AppConstants';
import Utils from 'general/utils/Utils';
import { t } from 'i18next';
import _ from 'lodash';

const ChargeTransactionHelper = {
  // ---- methods ----
  // lay chi tiet phien sac
  callApiGetChargeTransactionDetail: async (id) => {
    const res = await chargeTransactionApi.getChargeTransactionDetail(id);
    const { result, chargeTransaction } = res;
    if (result === 'success' && chargeTransaction) {
      return chargeTransaction;
    }
    return {};
  },

  // lay ds phien sac
  callApiGetChargeTransactionList: async (params) => {
    const res = await chargeTransactionApi.getChargeTransactionList(params);
    const { result, chargeTransactions, total } = res;
    if (result === 'success') {
      return { chargeTransactions, total };
    }
    return {};
  },

  // lay mau trang thai phien sac
  getChargeTransactionStatusColor: (status) => {
    switch (status) {
      case AppConstants.chargeTransactionStatus.cancelled:
        return 'danger';
      case AppConstants.chargeTransactionStatus.failed:
        return 'danger';
      case AppConstants.chargeTransactionStatus.charging:
        return 'success';
      case AppConstants.chargeTransactionStatus.finished:
        return 'gray-600';
      case AppConstants.chargeTransactionStatus.finishing:
        return 'success';
      case AppConstants.chargeTransactionStatus.preparing:
        return 'warning';
      case AppConstants.chargeTransactionStatus.initiating:
        return 'primary';
      case AppConstants.chargeTransactionStatus.reserved:
        return 'gray-600';
      default:
        return 'danger';
    }
  },

  // kiem tra dang sac?
  isCharging: (status) => {
    return status == AppConstants.chargeTransactionStatus.charging;
  },
  isFinishing: (status) => {
    return status == AppConstants.chargeTransactionStatus.finishing;
  },
  isFinished: (status) => {
    return status == AppConstants.chargeTransactionStatus.finished;
  },
  isCancelled: (status) => {
    return status == AppConstants.chargeTransactionStatus.cancelled;
  },
  isFailed: (status) => {
    return status == AppConstants.chargeTransactionStatus.failed;
  },
  isReserved: (status) => {
    return status == AppConstants.chargeTransactionStatus.reserved;
  },

  getAmount: (item) => {
    const payments = item?.payments ?? [];
    const estimatedCost = item?.estimatedCost ?? 0;
    const currency = item?.currency ?? '';

    if (!_.isEmpty(payments)) {
      // return Utils.formatNumber(_.first(payments)?.amount) + ' ' + _.first(payments)?.currency;
      return Utils.formatNumber(_.first(payments)?.amount);
    }
    // return Utils.formatNumber(estimatedCost) + ' ' + currency;
    return Utils.formatNumber(estimatedCost);
  },

  // filter options
  filterStatusOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('chargeTransactionStatus_' + AppConstants.chargeTransactionStatus.cancelled),
        value: AppConstants.chargeTransactionStatus.cancelled,
      },
      {
        name: t('chargeTransactionStatus_' + AppConstants.chargeTransactionStatus.charging),
        value: AppConstants.chargeTransactionStatus.charging,
      },
      {
        name: t('chargeTransactionStatus_' + AppConstants.chargeTransactionStatus.finished),
        value: AppConstants.chargeTransactionStatus.finished,
      },
      {
        name: t('chargeTransactionStatus_' + AppConstants.chargeTransactionStatus.finishing),
        value: AppConstants.chargeTransactionStatus.finishing,
      },
      {
        name: t('chargeTransactionStatus_' + AppConstants.chargeTransactionStatus.initiating),
        value: AppConstants.chargeTransactionStatus.initiating,
      },
      {
        name: t('chargeTransactionStatus_' + AppConstants.chargeTransactionStatus.preparing),
        value: AppConstants.chargeTransactionStatus.preparing,
      },
    ];
  },
};

export default ChargeTransactionHelper;
